import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { LEGISLATION_FOLDER } from "../legislation-library-helpers"

export function LegislationLibraryChooseFolderRow({ item, onNavigate }) {
    const isFolder = item?.type === LEGISLATION_FOLDER
    const label = isFolder ? item.name : item.title
    const icon = isFolder ? "mdi:folder" : "mdi:scale-balance"
    const iconColor = isFolder ? "sfg20.medium" : "text.disabled"
    const dataCy = isFolder ? "legislation-choose-folder-folder-row" : "legislation-choose-folder-legislation-row"

    return (
        <ListItemButton onClick={handleClick} disabled={!isFolder} data-cy={dataCy}>
            <ListItemIcon>
                <Iconify icon={icon} width={20} height={20} sx={{ color: iconColor }} />
            </ListItemIcon>
            <ListItemText primary={label} />
            <If value={isFolder}>
                <Iconify icon="mdi:chevron-right" width={20} height={20} />
            </If>
        </ListItemButton>
    )

    function handleClick() {
        if (isFolder) onNavigate(item.id)
    }
}
